<template>
  <div>
    <van-nav-bar
      class="header"
      title="我的收藏"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="main">
        <ticket-scroll
          :url="'shop/new-goods-collect-list'"
          ref="collect"
          :emptyimg="true"
          :text2="'主人，暂无收藏哦~'"
        >
          <template slot-scope="scope">
            <div class="cards" v-for="(item, i) in scope.data" :key="i">
              <div
                class="img-box"
                @click="
                  $router.push({
                    name: 'shop.detail',
                    params: { id: item.goods_id },
                  })
                "
              >
                <img :src="item.img_url" alt="" />
              </div>
              <div class="state">
                <div class="title">{{ item.goods_name }}</div>
                <div class="num"></div>
                <div class="btn">
                  <p>
                    <span class="doll">&yen;</span>
                    <span class="price">{{
                      item.min_price == item.max_price
                        ? item.min_price
                        : item.min_price + "~" + item.max_price
                    }}</span>
                  </p>
                  <p class="cancelSc" @click="cancelHandle(item.goods_id)">
                    取消收藏
                  </p>
                </div>
              </div>
            </div>
          </template>
        </ticket-scroll>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import api from "../Api";
export default {
  mixins: [api],
  data() {
    return {
      collectList: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    cancelHandle(id) {
      this.$Ajax("/shop/new-goods-un-collect", {
        goodsId: id,
      }).then((res) => {
        if (res.code == 200) {
          this.$refs.collect.refresh();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 100;
}

.main {
  .cards {
    margin: 0.6rem 0.75rem;
    padding: 0.6rem;
    background-color: #ffffff;
    border-radius: 0.7rem;
    display: flex;

    .img-box {
      width: 3.75rem;
      height: 3.55rem;
      margin-right: 0.55rem;

      img {
        border-radius: 0.7rem;
        width: 100%;
        height: 100%;
      }
    }

    .state {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title {
        font-size: 0.7rem;
        color: #000000;
        font-weight: bold;
      }

      .num {
        color: #9e9e9e;
        font-size: 0.6rem;
      }

      .btn {
        display: flex;
        justify-content: space-between;
        align-items: end;

        .doll {
          font-size: 0.5rem;
          color: #670000;
        }

        .price {
          font-size: 0.8rem;
          font-weight: bold;
          color: #670000;
        }

        .cancelSc {
          padding: 0.15rem 0.5rem;
          background-color: #f3f2f2;
          border-radius: 1rem;
          font-size: 0.6rem;
          color: #9e9e9e;
        }
      }
    }
  }
}
</style>
